import { Link } from 'react-router-dom'
import { Button } from 'src/core/ds/button'
import { ButtonSizes } from 'src/core/ds/button/types'
import styles from '../index.module.scss'

export function Hero({ currentUser }) {
  return (
    <div className={styles.hero}>
      <a href="https://muvon.io" target="_blank" className={styles.muvon} rel="noreferrer">
        <span>
          built by
          <svg width="126" height="40" viewBox="0 0 126 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.7757" cy="6.04188" r="6.04188" fill="#76B744" />
            <circle cx="37.5282" cy="31.2601" r="6.04188" fill="#76B744" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.4889 14.7002C40.6847 18.0313 38.1431 20.8904 34.812 21.0862C33.2728 21.1767 31.6218 21.4473 30.5785 22.5826L25.4075 28.2087C24.2377 29.4814 24.1311 31.3703 24.1311 33.099C24.1311 36.4359 21.4261 39.1409 18.0892 39.1409C14.7524 39.1409 12.0473 36.4359 12.0473 33.099C12.0473 33.0689 12.0475 33.0387 12.048 33.0087C12.0696 31.5357 11.9005 29.9507 10.8815 28.8867C9.74425 27.6992 7.93379 27.5495 6.29084 27.615C6.01445 27.6261 5.73401 27.6182 5.45092 27.5904C2.13011 27.2638 -0.297169 24.3069 0.0294542 20.9861C0.356077 17.6653 3.31291 15.238 6.63373 15.5646C9.95454 15.8913 12.3818 18.8481 12.0552 22.1689C11.9519 23.2191 12.1129 24.3374 12.8427 25.0995L13.3778 25.6582C14.5465 26.8785 16.3995 27.0571 18.0892 27.0571C19.5836 27.0571 21.1971 26.8255 22.2084 25.7252L27.3209 20.1627C28.456 18.9277 28.5244 17.0838 28.426 15.4092C28.2302 12.0781 30.7718 9.21903 34.1029 9.02323C37.434 8.82742 40.2931 11.3691 40.4889 14.7002Z"
              fill="#76B744"
            />
            <path
              d="M65.6534 17.4566C65.3946 16.9132 64.8877 16.6414 64.1329 16.6414C63.2559 16.6414 62.6664 16.9132 62.3644 17.4566C62.1991 17.7661 62.1164 18.227 62.1164 18.8392V25.6079H59V14.3818H61.987V16.0224C62.368 15.4377 62.7275 15.0215 63.0654 14.7739C63.662 14.3336 64.4348 14.1135 65.3838 14.1135C66.2824 14.1135 67.0085 14.3027 67.562 14.681C68.0078 15.0318 68.3456 15.4824 68.5757 16.0327C68.9783 15.3723 69.4779 14.8874 70.0746 14.5778C70.7072 14.2683 71.4117 14.1135 72.1881 14.1135C72.7057 14.1135 73.2161 14.2098 73.7194 14.4024C74.2226 14.595 74.6791 14.9321 75.0889 15.4136C75.4196 15.8057 75.6424 16.2872 75.7574 16.8581C75.8293 17.2365 75.8653 17.7902 75.8653 18.5193L75.8437 25.6079H72.6949V18.4471C72.6949 18.0206 72.6231 17.6698 72.4793 17.3947C72.2061 16.8719 71.7029 16.6105 70.9696 16.6105C70.1213 16.6105 69.5354 16.9475 69.2119 17.6217C69.0466 17.9794 68.9639 18.4093 68.9639 18.9114V25.6079H65.869V18.9114C65.869 18.2442 65.7972 17.7592 65.6534 17.4566Z"
              fill="var(--color-text)"
            />
            <path
              d="M85.5764 24.0189C85.5476 24.0533 85.4757 24.1565 85.3607 24.3285C85.2457 24.5004 85.1091 24.6518 84.951 24.7825C84.4693 25.1952 84.002 25.4772 83.5491 25.6285C83.1034 25.7799 82.5786 25.8555 81.9747 25.8555C80.235 25.8555 79.0632 25.2571 78.4593 24.0602C78.1215 23.3998 77.9525 22.4265 77.9525 21.1402V14.3611H81.1013V21.1402C81.1013 21.7799 81.1804 22.2614 81.3385 22.5847C81.6189 23.1556 82.1688 23.4411 82.9884 23.4411C84.038 23.4411 84.7569 23.0353 85.1451 22.2236C85.3463 21.7833 85.447 21.2021 85.447 20.4798V14.3611H88.5634V25.6079H85.5764V24.0189Z"
              fill="var(--color-text)"
            />
            <path
              d="M89.7233 14.3611H93.174L95.6218 22.6569L98.1236 14.3611H101.423L97.1854 25.6079H93.9396L89.7233 14.3611Z"
              fill="var(--color-text)"
            />
            <path
              d="M112.31 15.785C113.302 16.9751 113.798 18.3818 113.798 20.0052C113.798 21.6561 113.302 23.0696 112.31 24.2459C111.318 25.4153 109.812 26 107.792 26C105.771 26 104.265 25.4153 103.273 24.2459C102.281 23.0696 101.785 21.6561 101.785 20.0052C101.785 18.3818 102.281 16.9751 103.273 15.785C104.265 14.595 105.771 14 107.792 14C109.812 14 111.318 14.595 112.31 15.785ZM107.781 16.4867C106.882 16.4867 106.188 16.7928 105.7 17.405C105.218 18.0103 104.977 18.877 104.977 20.0052C104.977 21.1333 105.218 22.0034 105.7 22.6156C106.188 23.2279 106.882 23.534 107.781 23.534C108.679 23.534 109.37 23.2279 109.851 22.6156C110.333 22.0034 110.574 21.1333 110.574 20.0052C110.574 18.877 110.333 18.0103 109.851 17.405C109.37 16.7928 108.679 16.4867 107.781 16.4867Z"
              fill="var(--color-text)"
            />
            <path
              d="M120.878 16.5383C119.835 16.5383 119.12 16.9613 118.732 17.8074C118.531 18.2545 118.43 18.8255 118.43 19.5202V25.6079H115.368V14.3818H118.333V16.0224C118.728 15.4445 119.102 15.0284 119.454 14.7739C120.087 14.3199 120.889 14.0929 121.859 14.0929C123.074 14.0929 124.066 14.399 124.835 15.0112C125.612 15.6165 126 16.6242 126 18.0344V25.6079H122.851V18.767C122.851 18.1754 122.769 17.7214 122.603 17.405C122.301 16.8272 121.726 16.5383 120.878 16.5383Z"
              fill="var(--color-text)"
            />
          </svg>
        </span>
      </a>
      <div className={styles.launch}>
        <span>Released: Claude 3, Gemini Pro. Next: Mobile App</span>
      </div>

      <div className={styles.launch}>
        <a
          href="https://www.producthunt.com/posts/ai-marketplace-by-zentask-ai?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-ai&#0045;marketplace&#0045;by&#0045;zentask&#0045;ai"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'flex' }}
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=389893&theme=dark&period=daily"
            alt="AI&#0032;Marketplace&#0032;by&#0032;Zentask&#0046;ai - The&#0032;Spotify&#0032;of&#0032;AI&#0032;solutions&#0032;to&#0032;simplify&#0032;your&#0032;daily&#0032;tasks | Product Hunt"
            style={{ width: 200, height: 43 }}
            width="200"
            height="43"
          />
        </a>

        <a
          href="https://www.producthunt.com/posts/ai-marketplace-by-zentask-ai?utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_souce=badge-ai&#0045;marketplace&#0045;by&#0045;zentask&#0045;ai"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'flex' }}
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/top-post-topic-badge.svg?post_id=389893&theme=dark&period=weekly&topic_id=237"
            alt="AI&#0032;Marketplace&#0032;by&#0032;Zentask&#0046;ai - The&#0032;Spotify&#0032;of&#0032;AI&#0032;solutions&#0032;to&#0032;simplify&#0032;your&#0032;daily&#0032;tasks | Product Hunt"
            style={{ width: 200, height: 43 }}
            width="200"
            height="43"
          />
        </a>
      </div>
      {/* <h1>
            Simplify your daily Tasks
            <br />
            with
            <span> AI Assistance</span>
          </h1> */}
      {/* <h1>
            Save Time, Money
            <br />
            & 10X Productivity with
            <br />
            <span>AI-Powered Solutions</span>
          </h1> */}
      <h1>
        Smart All-in-one AI
        <br />
        for daily tasks
        <br />
        <span>with all models included</span>
      </h1>
      <p>
        Create articles, images, and videos. Talk to most popular AI models. Boost your productivity.
        <br />
        ChatGPT (GPT 3.5 and GPT 4), Claude, Gemini Pro, Stable Diffusion, Pixart, Flux.1 and more!
      </p>

      {currentUser && (
        <div className={styles.form}>
          <Link to="/chat/talk-to-zentask">
            <Button type="button" size={ButtonSizes.xl} label="Talk to Zentask" />
          </Link>
        </div>
      )}

      {!currentUser && (
        <div className={styles.form}>
          <Link to="/login">
            <Button label="Get started for free" type="button" />
          </Link>
        </div>
      )}
      {!currentUser && <div className={styles.bonus}>No credit card required</div>}

      <div className={styles.others}>
        <div className={styles.stackedAvatars}>
          <img
            src="https://ph-avatars.imgix.net/3259959/469bf616-bc06-424f-86d6-810c0a18e635?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=36&h=36&fit=crop&dpr=2"
            loading="lazy"
            width="36"
            height="36"
            alt="Social proof users"
          />
          <img
            src="https://ph-avatars.imgix.net/581391/23b58d4d-ab80-4d01-94b4-62c2b97859a8?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=36&h=36&fit=crop&dpr=2"
            loading="lazy"
            width="36"
            height="36"
            alt="Social proof users"
          />
          <img
            src="https://ph-avatars.imgix.net/5136189/ff275044-b287-4562-a447-ceffc0333186?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=36&h=36&fit=crop&dpr=2"
            loading="lazy"
            width="36"
            height="36"
            alt="Social proof users"
          />
          <img
            src="https://ph-avatars.imgix.net/5415947/original?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=36&h=36&fit=crop&dpr=2"
            loading="lazy"
            width="36"
            height="36"
            alt="Social proof users"
          />
          <img
            src="https://ph-avatars.imgix.net/4955004/4d8950c7-10b4-4a14-ba54-efd9be352b38?auto=compress&codec=mozjpeg&cs=strip&auto=format&w=36&h=36&fit=crop&dpr=2"
            loading="lazy"
            width="36"
            height="36"
            alt="Social proof users"
          />
        </div>

        <p>Join 80k+ others</p>
      </div>

      <section className={styles.students}>
        <p>Join companies and teams that are using Zentask:</p>
        <div className={styles.list}>
          <img
            src="https://imagedelivery.net/xBo-ZS_SWUoleWeSRokYNQ/b74b232a-ec39-45d7-4a2c-fa0716df6e00/large"
            alt="companies using zentask"
            loading="lazy"
            width="1160"
            height="140"
          />
        </div>
      </section>

      <div className={styles.download}>
        <span>Desktop Apps On-The-Go</span>
        <div className={styles.downloadList}>
          <a
            href="https://www.dropbox.com/scl/fi/xsanrp91207922pl1h5th/Zentask-Setup-1.0.1.exe?rlkey=qk9kjtqc504i6nf4618n15buu&dl=1"
            target="_blank"
            className={styles.downloadItem}
            rel="noreferrer"
          >
            <img
              src="https://imagedelivery.net/xBo-ZS_SWUoleWeSRokYNQ/7ef33e53-7184-41c7-261c-27c5fc922d00/small"
              alt="Download Zentask.ai desktop app for Windows"
            />
          </a>
          <a
            href="https://www.dropbox.com/scl/fi/34225cil8o5smjgzqupyi/Zentask-1.0.1-amd64.dmg?rlkey=b7f1zxfyuhxyvrpp25rhgh2wk&dl=1"
            target="_blank"
            className={styles.downloadItem}
            rel="noreferrer"
          >
            <img
              src="https://imagedelivery.net/xBo-ZS_SWUoleWeSRokYNQ/b8f5739a-73fc-4a69-1304-2c5b0ef7e100/small"
              alt="Download Zentask.ai desktop app for Mac OS x64"
            />
          </a>
          <a
            href="https://www.dropbox.com/scl/fi/sdcs6fnoldfkjrs2oigft/Zentask-1.0.1-arm64.dmg?rlkey=cuwd1dc02rocuisfvio6exjen&dl=1"
            target="_blank"
            className={styles.downloadItem}
            rel="noreferrer"
          >
            <img
              src="https://imagedelivery.net/xBo-ZS_SWUoleWeSRokYNQ/90d2e21a-2517-4a0c-b941-c4eed415be00/small"
              alt="Download Zentask.ai desktop app for Mac OS ARM"
            />
          </a>
        </div>
      </div>
    </div>
  )
}
